import { useTranslation } from 'react-i18next';

export default function Scenarios() {
  const { t } = useTranslation('home');
  const scenarios = t('scenarios.items', { returnObjects: true }) as Array<{
    title: string;
    desc: string;
    points: string[];
  }>;

  return (
    <section id="scenarios" className="py-10 md:py-14 bg-slate-50">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="mb-6">
            <div className="text-xs font-medium text-slate-400 uppercase tracking-wider mb-2">{t('scenarios.subtitle')}</div>
            <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-slate-900">
              {t('scenarios.title')}
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {scenarios.map((item, idx) => (
              <div
                key={item.title}
                className={`bg-white border border-slate-200 rounded-lg p-5 hover:border-brand-300 hover:shadow-sm transition-all ${
                  idx === 0 ? 'sm:col-span-2 lg:col-span-1' : ''
                }`}
              >
                <h3 className="text-base font-bold text-slate-900 mb-2">{item.title}</h3>
                <p className="text-sm text-slate-600 leading-relaxed mb-3">{item.desc}</p>
                {item.points.length > 0 && (
                  <ul className="space-y-1">
                    {item.points.map((pt) => (
                      <li key={pt} className="text-xs text-slate-500 flex items-center gap-1.5">
                        <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 flex-shrink-0"></span>
                        {pt}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}